import PropTypes from 'prop-types';

import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';
import styled from 'styled-components';

/* istanbul ignore next */
const modifierConfig = {
  warning: ({ theme }) => ({
    styles: `
      color: ${theme.colors.status.warning};
    `,
  }),
};

/* istanbul ignore next */
const styles = props => `
  color: ${props.theme.colors.base.chrome600};
  font-size: ${px2rem(10)};
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      chrome600: PropTypes.string.isRequired,
    }).isRequired,
    status: PropTypes.shape({
      warning: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent(
  'RecipientLabel',
  styled.span,
  styles,
  { modifierConfig, themePropTypes },
);



// WEBPACK FOOTER //
// ./compositions/NotesWidget/NoteCreator/RecipientCount/RecipientLabel.js